import styles from "./Card.module.css";

export const Card = ({ children, className }) => {
  return <div style={{overflow:"auto"}} className={`${styles.card} ${className}`}>{children}</div>;
};
